let zhaotongTownship= [
    // {
    //     "label": "昭阳区",
    //     "value": "昭阳区",
    //     "token": "CN^^^云南省^^^昭通市^^^昭阳区"
    // },
    // {
    //     "label": "鲁甸县",
    //     "value": "鲁甸县",
    //     "token": "CN^^^云南省^^^昭通市^^^鲁甸县"
    // },
    // {
    //     "label": "巧家县",
    //     "value": "巧家县",
    //     "token": "CN^^^云南省^^^昭通市^^^巧家县"
    // },
    {
        "label": "盐津县",
        "value": "盐津县",
        "token": "CN^^^云南省^^^昭通市^^^盐津县"
    },
    {
        "label": "大关县",
        "value": "大关县",
        "token": "CN^^^云南省^^^昭通市^^^大关县"
    },
    {
        "label": "永善县",
        "value": "永善县",
        "token": "CN^^^云南省^^^昭通市^^^永善县"
    },
    {
        "label": "绥江县",
        "value": "绥江县",
        "token": "CN^^^云南省^^^昭通市^^^绥江县"
    },
    {
        "label": "其他",
        "value": "其他",
        "token": "CN^^^云南省^^^昭通市^^^其他"
    }
    // {
    //     "label": "镇雄县",
    //     "value": "镇雄县",
    //     "token": "CN^^^云南省^^^昭通市^^^镇雄县"
    // },
    // {
    //     "label": "彝良县",
    //     "value": "彝良县",
    //     "token": "CN^^^云南省^^^昭通市^^^彝良县"
    // },
    // {
    //     "label": "威信县",
    //     "value": "威信县",
    //     "token": "CN^^^云南省^^^昭通市^^^威信县"
    // },
    // {
    //     "label": "水富市",
    //     "value": "水富市",
    //     "token": "CN^^^云南省^^^昭通市^^^水富市"
    // }
]
export { zhaotongTownship };